var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "componentCreatePropertyModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.create_component_property"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createProperty()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.create")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-1",
            label: this.$t("message.group_name"),
            "label-for": "input-1",
          },
        },
        [
          _c("b-form-input", {
            attrs: { id: "input-1", trim: "" },
            model: {
              value: _vm.groupName,
              callback: function ($$v) {
                _vm.groupName = $$v
              },
              expression: "groupName",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-2",
            label: this.$t("message.property_name"),
            "label-for": "input-2",
            "label-class": "required",
          },
        },
        [
          _c("b-form-input", {
            staticClass: "required",
            attrs: { id: "input-2", trim: "" },
            model: {
              value: _vm.propertyName,
              callback: function ($$v) {
                _vm.propertyName = $$v
              },
              expression: "propertyName",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-3",
            label: this.$t("message.property_value"),
            "label-for": "input-3",
            "label-class": "required",
          },
        },
        [
          _c("b-form-textarea", {
            staticClass: "required",
            attrs: { id: "input-3", trim: "" },
            model: {
              value: _vm.propertyValue,
              callback: function ($$v) {
                _vm.propertyValue = $$v
              },
              expression: "propertyValue",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-4",
            label: this.$t("message.property_type"),
            "label-for": "input-4",
            "label-class": "required",
          },
        },
        [
          _c("b-form-select", {
            staticClass: "required",
            attrs: { id: "input-4", options: _vm.options },
            model: {
              value: _vm.propertyType,
              callback: function ($$v) {
                _vm.propertyType = $$v
              },
              expression: "propertyType",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-5",
            label: this.$t("message.description"),
            "label-for": "input-5",
          },
        },
        [
          _c("b-form-textarea", {
            attrs: { id: "input-5", trim: "" },
            model: {
              value: _vm.description,
              callback: function ($$v) {
                _vm.description = $$v
              },
              expression: "description",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }